const routes = [
{
  path: '/testyhj',
  name: 'TestYhj',
  component: () => import('@src/common/view/test/TestYhj'),
  meta: {
    requireAuth: true
  }
},
{
  path: '/homeNew',
  name: 'HomeNew',
  component: () => import('@src/common/view/HomeNew'),
  meta: {
    requireAuth: true
  }
}
];
export default routes
